import type { QueryKey, UseQueryResult, UseQueryOptions, QueryOptions } from "@tanstack/react-query";
import { useQuery } from "@tanstack/react-query";
import client from "@/api/client/axios";
import type { GetSliderBannersQueryResponse, GetSliderBannersQueryParams, GetSliderBanners400, GetSliderBanners500 } from "../types/GetSliderBanners";

export const getSliderBannersQueryKey = (params?: GetSliderBannersQueryParams) =>     [{url:`/api/mainPage/slider_banners`},...(params ? [params] : [])] as const;
      export function getSliderBannersQueryOptions <TData = GetSliderBannersQueryResponse, TError = GetSliderBanners400 | GetSliderBanners500>(params?: GetSliderBannersQueryParams, options: Partial<Parameters<typeof client>[0]> = {}): UseQueryOptions<TData, TError> {
        const queryKey = getSliderBannersQueryKey(params);

        return {
          queryKey,
          queryFn: () => {
            
            return client<TData, TError>({
              method: "get",
              url: `/api/mainPage/slider_banners`,
              params,
              
              ...options,
            }).then(res => res.data);
          },
        };
      };
      
/**
 * @summary Получение баннеров карулеси для главной страницы в соответствии с регионом 
 * @link /api/mainPage/slider_banners
 */

export function useGetSliderBanners <TData = GetSliderBannersQueryResponse, TError = GetSliderBanners400 | GetSliderBanners500>(params?: GetSliderBannersQueryParams, options: {
          query?: UseQueryOptions<TData, TError>,
          client?: Partial<Parameters<typeof client<TData, TError>>[0]>,
        } = {}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const { query: queryOptions, client: clientOptions = {} } = options ?? {};
  const queryKey = queryOptions?.queryKey ?? getSliderBannersQueryKey(params);

  const query = useQuery<TData, TError>({
    ...getSliderBannersQueryOptions<TData, TError>(params, clientOptions),
    ...queryOptions
  }) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey as QueryKey;

  return query;
};
